<template>
    <div>
        <!-- Modal planification intervention -->
        <!-- <modal name="modal-planify-intervention" height="auto" width="70%" :scrollable="true">
            <div class="p-6 min-h-[50vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Horaires à proposer à votre client</h2>
                    <button @click="$modal.hide('modal-planify-intervention');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="planIntervention">
                    <intervention-plan-manual :intervention="planIntervention" @planned="manualPlan" />
                </div>
            </div>
        </modal> -->

        <!-- Modal view intervention -->
        <modal name="modal-view-intervention" height="auto" :scrollable="true" :adaptive="true" width="850px">
            <div class="p-8 overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-folder-open text-red-600"></i>
                        Intervention
                    </h2>
                    <button @click="$modal.hide('modal-view-intervention')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <div v-if="selectedIntervention">
                    <intervention-view :intervention-id="selectedIntervention.id" />
                </div>
            </div>
        </modal>

        <!-- Modal création intervention -->
        <modal name="modal-create-intervention" height="auto" :scrollable="true" :adaptive="true" :width="modalInterventionWidth">
            <div class="p-8 overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-plus text-red-600"></i>
                        Nouvelle intervention
                    </h2>
                    <button @click="$modal.hide('modal-create-intervention')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <div v-if="chantier">
                    <intervention-form-chantier
                    v-model="newIntervention"
                    :client_id="chantier.client.id"
                    :travaux_id="chantier.id"
                    :adresse_id="chantier.adresse_id"
                    />
                    <button v-if="newIntervention.duree_estimee && newIntervention.type_id" @click="createIntervention" :disabled="loadingNewIntervention" class="bg-red-600 text-white rounded-lg px-4 py-2 mt-4">
                        <template v-if="loadingNewIntervention">
                            <i class="fas fa-spinner fa-spin"></i> Création en cours...
                        </template>
                        <template v-if="!loadingNewIntervention">
                            <i class="fas fa-plus mr-1"></i> Créer l'intervention
                        </template>
                    </button>
                </div>
            </div>
        </modal>

        <div class="space-y-6">
            <div v-if="loadingGetChantier" class="space-y-6">
                <!-- Header Skeleton -->
                <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
                        <div class="flex-1">
                            <div class="h-8 bg-gray-200 rounded w-64 mb-2"></div>
                            <div class="h-4 bg-gray-200 rounded w-32"></div>
                        </div>
                        <div class="flex items-center gap-4">
                            <div class="h-6 bg-gray-200 rounded-full w-24"></div>
                            <div class="h-8 w-8 bg-gray-200 rounded-full"></div>
                        </div>
                    </div>
                </div>

                <!-- Tabs Skeleton -->
                <div class="bg-gray-100 p-1.5 rounded-xl inline-flex gap-1">
                    <div class="h-10 bg-gray-200 rounded-lg w-32"></div>
                    <div class="h-10 bg-gray-200 rounded-lg w-36"></div>
                    <div class="h-10 bg-gray-200 rounded-lg w-28"></div>
                    <div class="h-10 bg-gray-200 rounded-lg w-32"></div>
                    <div class="h-10 bg-gray-200 rounded-lg w-32"></div>
                    <div class="h-10 bg-gray-200 rounded-lg w-32"></div>
                </div>

                <!-- Content Skeleton -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                        <div class="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                        <div class="space-y-4">
                            <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-16"></div>
                                <div class="h-4 bg-gray-200 rounded w-32"></div>
                            </div>
                            <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-16"></div>
                                <div class="h-4 bg-gray-200 rounded w-40"></div>
                            </div>
                            <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-20"></div>
                                <div class="h-4 bg-gray-200 rounded w-36"></div>
                            </div>
                            <div class="flex justify-between items-center">
                                <div class="h-4 bg-gray-200 rounded w-16"></div>
                                <div class="h-4 bg-gray-200 rounded w-44"></div>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                        <div class="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                        <div class="space-y-4">
                            <div class="pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                                <div class="h-4 bg-gray-200 rounded w-full mb-1"></div>
                                <div class="h-4 bg-gray-200 rounded w-48"></div>
                            </div>
                            <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                <div class="h-4 bg-gray-200 rounded w-32"></div>
                                <div class="h-4 bg-gray-200 rounded w-36"></div>
                            </div>
                            <div>
                                <div class="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                                <div class="h-20 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loadingGetChantier && chantier" class="space-y-6">
                <div class="bg-gray-100 p-1.5 rounded-xl inline-flex flex-wrap gap-1">
                    <button 
                        v-for="tab in tabs" :key="tab.id"
                        @click="selectedTab = tab.id"
                        :class="[
                            selectedTab === tab.id 
                            ? 'bg-white text-red-600 shadow-sm font-semibold' 
                            : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200 font-medium',
                            'px-5 py-2 rounded-lg text-sm transition-all duration-200 flex items-center cursor-pointer'
                        ]"
                    >
                        <i :class="[tab.icon, 'mr-2', selectedTab === tab.id ? 'text-red-500' : 'text-gray-400']"></i>
                        {{ tab.label }}
                    </button>
                </div>
                
                <div class="mt-4">
                    
                    <div v-show="selectedTab === 'info'" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <!-- <div class="col-span-2 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between">
                            <div>
                                <div class="flex items-center space-x-3">
                                    <h1 class="text-2xl font-bold text-gray-800 capitalize">
                                        {{ chantier.client.prenom }} {{ chantier.client.nom }}
                                    </h1>
                                </div>
                            </div>
                            <div class="text-right text-sm text-gray-400 flex justify-end items-center gap-4">
                                <span 
                                    class="px-3 py-1 rounded-full text-xs font-semibold"
                                    :style="{ backgroundColor: chantier.statut.couleur + '15', color: chantier.statut.couleur }"
                                >
                                    {{ chantier.statut.libelle }}
                                </span>
                            </div>
                        </div> -->
                        <div>
                            <div id="intervention-map-chantier" class="w-full h-[452px] md:h-[452px] rounded-lg shadow"></div>
                        </div>

                        <div class="space-y-6">
                            <div v-if="!chantier.terminer">
                                <div class="flex items-center space-x-3">
                                    <button :disabled="loadingTerminer" @click="terminer" class="bg-yellow-500 hover:bg-yellow-600 duration-200 text-white px-4 py-2 rounded-lg">
                                        <template v-if="loadingTerminer">
                                            <i class="fas fa-spinner fa-spin"></i>
                                        </template>
                                        <template v-if="!loadingTerminer">
                                            <i class="fas fa-ban mr-1"></i> Terminer le chantier
                                        </template>
                                    </button>
                                </div>
                            </div>
    
                            <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                                <h2 class="text-lg font-semibold mb-4 text-gray-800">Lieu d'intervention</h2>
                                <div class="space-y-4">
                                    <div class="pb-3 border-b border-gray-50">
                                        <span class="block text-sm text-gray-500 mb-1">Adresse complète</span>
                                        <div class="font-medium text-gray-800">{{ chantier.adresse.adresse1 }}</div>
                                        <div v-if="chantier.adresse.adresse2" class="text-sm text-gray-600">{{ chantier.adresse.adresse2 }}</div>
                                        <div class="text-sm text-gray-600">{{ chantier.adresse.code_postal }} {{ chantier.adresse.ville }}</div>
                                    </div>
                                    <div v-if="chantier.adresse.nom_contact" class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Contact sur place</span>
                                        <span class="font-medium text-gray-800">{{ chantier.adresse.nom_contact }}</span>
                                    </div>
                                    <div v-if="chantier.adresse.acces" class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Code d'accès</span>
                                        <span v-if="chantier.adresse.acces" class="font-mono bg-gray-100 px-2 py-1 rounded text-gray-800 text-sm">{{ chantier.adresse.acces }}</span>
                                    </div>
                                    <div v-if="chantier.adresse.notes">
                                        <span class="block text-sm text-gray-500 mb-1">Notes importantes</span>
                                        <p class="text-sm text-gray-700 bg-gray-50 p-3 rounded-lg border border-gray-100">{{ chantier.adresse.notes }}</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                                <h2 class="text-lg font-semibold mb-4 text-gray-800">Détails du Client</h2>
                                <div class="space-y-4">
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Type</span>
                                        <span class="font-medium text-gray-800 capitalize">{{ chantier.client.type_client }}</span>
                                    </div>
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Email</span>
                                        <a :href="'mailto:' + chantier.client.email" class="text-sm font-medium text-red-600 hover:underline">{{ chantier.client.email }}</a>
                                    </div>
                                    <div class="flex justify-between items-center pb-3 border-b border-gray-50">
                                        <span class="text-sm text-gray-500">Téléphone</span>
                                        <a :href="'tel:' + chantier.client.telephone" class="text-sm font-medium text-red-600 hover:underline">{{ chantier.client.telephone }}</a>
                                    </div>
                                    <div v-if="chantier.client.siret" class="flex justify-between items-center">
                                        <span class="text-sm text-gray-500">SIRET</span>
                                        <span class="text-sm font-medium text-gray-800">{{ chantier.client.siret }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="selectedTab === 'interventions'">
                        <template v-if="loadingReloadIntervention">
                            <div class="flex flex-col items-center justify-center py-16 bg-white rounded-2xl border border-gray-100 shadow-sm">
                                <div class="relative w-16 h-16 mb-4">
                                    <div class="absolute inset-0 rounded-full border-4 border-gray-100"></div>
                                    <div class="absolute inset-0 rounded-full border-4 border-red-500 border-t-transparent animate-spin"></div>
                                </div>
                                <p class="text-sm font-semibold text-gray-700">Chargement des interventions</p>
                                <p class="text-xs text-gray-400 mt-1">Veuillez patienter...</p>
                            </div>
                        </template>
                        <template v-if="!loadingReloadIntervention">
                            <div class="mb-8 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div class="flex justify-between items-end mb-4">
                                    <div>
                                        <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wider">Planification du temps</h3>
                                        <p class="text-2xl font-bold" :class="chantierTemps.isOverflow ? 'text-red-600' : 'text-slate-800'">
                                            {{ chantierTemps.reste.toFixed(1) }} <span class="text-lg font-medium text-gray-400">heures restantes</span>
                                        </p>
                                    </div>
                                    <div class="text-right">
                                        <span class="text-sm font-medium text-gray-600">
                                            {{ chantierTemps.totalPlanifie.toFixed(1) }}h / {{ chantierTemps.totalDispo.toFixed(1) }}h
                                        </span>
                                    </div>
                                </div>

                                <div class="relative w-full h-4 bg-gray-100 rounded-full overflow-hidden">
                                    <div 
                                        class="h-full transition-all duration-500 ease-out"
                                        :class="[
                                            chantierTemps.isOverflow ? 'bg-red-500' : 'bg-emerald-500',
                                            chantierTemps.pourcentage > 90 && !chantierTemps.isOverflow ? 'bg-orange-400' : ''
                                        ]"
                                        :style="{ width: (chantierTemps.pourcentage > 100 ? 100 : chantierTemps.pourcentage) + '%' }"
                                    ></div>
                                </div>

                                <div class="flex mt-3 items-center justify-between">
                                    <div class="flex gap-4">
                                        <div class="flex items-center text-xs text-gray-500">
                                            <span class="w-2 h-2 rounded-full bg-emerald-500 mr-2"></span> Planifié
                                        </div>
                                        <div class="flex items-center text-xs text-gray-500">
                                            <span class="w-2 h-2 rounded-full bg-gray-200 mr-2"></span> Disponible
                                        </div>
                                    </div>
                                    
                                    <div v-if="chantierTemps.isOverflow" class="flex items-center text-xs font-bold text-red-600 bg-red-50 px-2 py-1 rounded">
                                        <i class="fas fa-exclamation-triangle mr-1"></i> Dépassement de {{ Math.abs(chantierTemps.reste).toFixed(1) }}h
                                    </div>
                                </div>
                            </div>
                            <button @click="newIntervention = {}; $modal.show('modal-create-intervention')" class="mb-4 bg-red-600 hover:bg-red-700 duration-200 text-white px-4 py-2 rounded-lg">
                                <i class="fas fa-plus mr-1"></i> Nouvelle intervention
                            </button>
                            <div class="overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-100">
                                <table class="w-full text-sm text-left">
                                    <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                        <tr>
                                            <th class="px-6 py-3">Référence</th>
                                            <th class="px-6 py-3">Type</th>
                                            <th class="px-6 py-3">Statut</th>
                                            <th class="px-6 py-3">Technicien</th>
                                            <th class="px-6 py-3">Date</th>
                                            <th class="px-6 py-2">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-100">
                                        <tr v-for="intervention in chantier.interventions" :key="intervention.id">
                                            <td class="px-6 py-4 font-medium text-gray-800">{{ intervention.reference }}</td>
                                            <td class="px-6 py-4">
                                                <div class="text-gray-800 text-xs ">{{ intervention.intervention_type?.nom || '-' }}</div>
                                            </td>
                                            <td class="px-6 py-4">
                                                <div class="text-xs font-light">
                                                    {{ intervention.statut.libelle }}
                                                </div>
                                            </td>
                                            <td class="px-6 py-4 text-gray-600">
                                                <span v-if="intervention.technicien">{{ intervention.technicien.prenom }} {{ intervention.technicien.nom }}</span>
                                                <span v-else class="text-gray-400 italic">Non assigné</span>
                                            </td>
                                            <td class="px-6 py-4 text-gray-600">
                                                {{ intervention.date_intervention ? new Date(intervention.date_intervention).toLocaleDateString('fr-FR') : '-' }}
                                            </td>
                                            <td class="px-6 py-4">
                                                <div class="flex items-center gap-2">
                                                    <button @click.stop="selectedIntervention = intervention; $modal.show('modal-view-intervention')" class="px-2 py-1 bg-slate-900 hover:bg-slate-700 duration-200 text-white rounded flex items-center gap-1.5">
                                                        <i class="fas fa-folder-open"></i> Consulter
                                                    </button>
                                                    <button v-if="intervention.statut.code === 'a_planifier'" @click.stop="supprimerIntervention(intervention.id)" class="px-2 py-1 text-red-500 rounded">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                                <!-- <button @click.stop="planifier(intervention)" class="ml-2 text-blue-600 hover:text-blue-800 font-medium">
                                                    <i class="fas fa-calendar-alt"></i> Planifier
                                                </button> -->
                                            </td>
                                        </tr>
                                        <tr v-if="chantier.interventions.length === 0">
                                            <td colspan="5" class="px-6 py-6 text-center text-gray-400">Aucune intervention</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div v-if="selectedTab === 'planning'" class="space-y-6">
                        <div>
                            <!-- <planner
                            :planning-date="'2026-02-28'"
                            :events="fakeEvents"
                            :techniciens="fakeTechniciens"
                            :unplanned-events="unplannedEvents"
                            /> -->

                            <!-- <intervention-planning-day
                            :date="'2026-02-28'"
                            :interventions="[]"
                            /> -->

                            <!-- <planning-planner :chantier-id="chantier.id" /> -->

                            <planning-half-day
                            :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                            heurefin-matin="12:00"
                            heure-debut-apres-midi="12:01"
                            :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                            :readonly="true"
                            :chantier-id="chantier.id"
                            :days="$account.account.societe.open_days"
                            />
                        </div>
                        <!-- @update-event="handleUpdate" -->
                        <!-- @create-event="handleCreate" -->
                    </div>

                    <div v-if="selectedTab === 'statistiques' && false" class="space-y-8 p-2">
                        
                        <div class="flex items-end justify-between">
                            <div>
                                <h2 class="text-3xl font-black text-slate-800 mt-3 tracking-tight">Progression & Performance</h2>
                            </div>
                            <div class="text-right hidden sm:block">
                                <p class="text-[10px] font-bold text-slate-400 uppercase">Score d'efficacité</p>
                                <div class="flex gap-1 mt-1">
                                    <div v-for="i in 5" :key="i" :class="['w-4 h-1.5 rounded-full', i <= 4 ? 'bg-emerald-500' : 'bg-slate-200']"></div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            
                            <div class="bg-white border-2 border-slate-100 rounded-[2rem] p-6 shadow-sm flex flex-col items-center text-center group hover:border-emerald-200 transition-all">
                                <div class="relative w-24 h-24 mb-4 flex items-center justify-center">
                                    <svg class="w-full h-full transform -rotate-90">
                                        <circle cx="48" cy="48" r="40" stroke="currentColor" stroke-width="8" fill="transparent" class="text-slate-100" />
                                        <circle cx="48" cy="48" r="40" stroke="currentColor" stroke-width="8" fill="transparent" stroke-dasharray="251" stroke-dashoffset="60" class="text-emerald-500 transition-all duration-1000" />
                                    </svg>
                                    <div class="absolute inset-0 flex flex-col items-center justify-center">
                                        <span class="text-xs font-black text-slate-400">MARGE</span>
                                        <span class="text-lg font-black text-slate-800">75%</span>
                                    </div>
                                </div>
                                <h3 class="text-xl font-black text-slate-800">{{ statsFakeData.marge }}</h3>
                                <p class="text-xs font-bold text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full mt-2">Objectif atteint</p>
                            </div>

                            <div class="lg:col-span-2 bg-gradient-to-br from-red-600 to-orange-600 rounded-[2rem] p-8 text-white relative overflow-hidden flex flex-col justify-between shadow-lg">
                                <div class="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-32 -mt-32"></div>
                                <div class="absolute bottom-0 left-0 w-48 h-48 bg-black opacity-10 rounded-full -ml-24 -mb-24"></div>
                                
                                <div class="relative z-10 flex justify-between">
                                    <div>
                                        <p class="text-orange-100 text-xs font-bold uppercase tracking-widest">Budget Engagé</p>
                                        <h3 class="text-4xl font-black mt-2 tracking-tighter">{{ statsFakeData.chiffreAffaire }}</h3>
                                    </div>
                                    <div class="text-right">
                                        <p class="text-orange-100 text-xs font-bold uppercase tracking-widest">Matériel</p>
                                        <p class="text-xl font-bold text-orange-200 mt-1">{{ statsFakeData.depenseMateriel }}</p>
                                    </div>
                                </div>
                                
                                <div class="relative z-10 mt-10">
                                    <div class="flex justify-between text-[10px] font-bold text-orange-100 uppercase mb-2">
                                        <span>Consommation Budget</span>
                                        <span>Limite : 15 000€</span>
                                    </div>
                                    <div class="h-3 w-full bg-red-800 bg-opacity-40 rounded-full p-0.5 border border-red-700 border-opacity-30">
                                        <div class="h-full bg-gradient-to-r from-yellow-400 to-orange-300 rounded-full shadow-[0_0_15px_rgba(251,191,36,0.6)]" style="width: 62%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div class="bg-slate-50 border border-slate-100 p-5 rounded-2xl flex flex-col items-center justify-center group hover:bg-white transition-all">
                                <div class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-indigo-500 mb-3 group-hover:scale-110 transition-transform">
                                    <i class="fas fa-stopwatch"></i>
                                </div>
                                <span class="text-lg font-black text-slate-800">{{ statsFakeData.tempsChantier }}</span>
                                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">Temps Total</span>
                            </div>
                            
                            <div class="bg-slate-50 border border-slate-100 p-5 rounded-2xl flex flex-col items-center justify-center group hover:bg-white transition-all">
                                <div class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-blue-500 mb-3 group-hover:scale-110 transition-transform">
                                    <i :class="statsFakeData.nbTechs > 1 ? 'fas fa-users' : 'fas fa-user'"></i>
                                </div>
                                <span class="text-lg font-black text-slate-800">{{ statsFakeData.nbTechs }}</span>
                                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">Techniciens</span>
                            </div>

                            <div class="bg-slate-50 border border-slate-100 p-5 rounded-2xl flex flex-col items-center justify-center group hover:bg-white transition-all">
                                <div class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-emerald-500 mb-3 group-hover:scale-110 transition-transform">
                                    <i class="fas fa-check-double"></i>
                                </div>
                                <span class="text-lg font-black text-slate-800">{{ statsFakeData.nbInterventions }}</span>
                                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">Interventions</span>
                            </div>

                            <div class="bg-slate-50 border border-slate-100 p-5 rounded-2xl flex flex-col items-center justify-center group hover:bg-white transition-all">
                                <div class="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-orange-500 mb-3 group-hover:scale-110 transition-transform">
                                    <i class="fas fa-microchip"></i>
                                </div>
                                <span class="text-lg font-black text-slate-800">{{ statsFakeData.nbAppareils }}</span>
                                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">Appareils</span>
                            </div>

                        </div>
                    </div>

                    <div v-if="selectedTab === 'documents'" class="grid grid-cols-2 md:grid-cols-6 gap-6">
                        <div class="col-span-2">
                            <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-dashed border-gray-200 p-6 mb-6 hover:border-red-300 transition-all">
                                <div class="flex items-center gap-3 mb-4">
                                    <div class="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
                                        <i class="fas fa-plus text-red-600"></i>
                                    </div>
                                    <h3 class="text-lg font-semibold text-gray-800">Ajouter un document</h3>
                                </div>
                                
                                <div class="space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            <i class="fas fa-paperclip text-red-500 mr-1"></i> Fichier
                                        </label>
                                        <input-file key-name="doc-intervention" v-model="newDoc.url" :preview="false" />
                                    </div>
                                    
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            <i class="fas fa-tag text-red-500 mr-1"></i> Type de document
                                        </label>
                                        <div class="relative">
                                            <select 
                                                v-model="newDoc.type" 
                                                class="w-full border border-gray-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-red-500 focus:border-red-500 transition appearance-none bg-white pr-10 text-gray-800"
                                            >
                                                <option value="" disabled selected>Sélectionner un type</option>
                                                <option v-for="(label, type) in docTypeLabel" :key="type" :value="type">{{ label }}</option>
                                            </select>
                                            <i class="fas fa-chevron-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                                        </div>
                                    </div>
                                    
                                    <button 
                                        :disabled="loadingAddDoc" 
                                        @click="addDocument" 
                                        class="w-full px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                                    >
                                        <template v-if="loadingAddDoc">
                                            <i class="fas fa-spinner fa-spin"></i>
                                            <span>Ajout en cours...</span>
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-upload"></i>
                                            <span>Ajouter le document</span>
                                        </template>
                                    </button>
                                </div>
                            </div>

                            <!-- Renvoyer les documents au client -->
                            <div class="bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-dashed border-gray-200 p-6 mb-6 hover:border-red-300 transition-all">
                                <div class="flex items-center gap-3 mb-4">
                                    <div class="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center">
                                        <i class="fas fa-paper-plane text-red-600"></i>
                                    </div>
                                    <h3 class="text-lg font-semibold text-gray-800">Envoyer les documents</h3>
                                </div>
                                <p class="text-sm text-gray-600 mb-4">Renvoyer les documents du chantier au client par email.</p>
                                <button :disabled="loadingResendDocuments" @click="resendDocuments" class="px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2">
                                    <template v-if="loadingResendDocuments">
                                        <i class="fas fa-spinner fa-spin"></i>
                                        <span>Envoi en cours...</span>
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-paper-plane"></i>
                                        <span>Renvoyer les documents</span>
                                    </template>
                                </button>
                            </div>
                        </div>
                        <div v-if="!chantier.documents || chantier.documents.filter((doc) => doc.type !== 'facture' && doc.type !== 'devis').length === 0" class="col-span-2 md:col-span-4">
                            <div class="bg-white p-6 rounded-2xl border border-gray-100 text-center text-gray-400">
                                <i class="fas fa-folder-open text-4xl mb-3"></i>
                                Aucun document trouvé.
                            </div>
                        </div>
                        <div class="col-span-2 md:col-span-4">
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                <div 
                                    v-for="doc in chantier.documents.filter((doc) => doc.type !== 'facture' && doc.type !== 'devis')"
                                    :key="'doc-' + doc.id" 
                                    class="bg-white rounded-2xl border border-gray-100 p-5 hover:border-red-300 hover:shadow-sm transition-all cursor-pointer text-center group"
                                >
                                    <a :href="doc.url" target="_blank" class="block w-full">
                                        <i :class="[
                                            'text-4xl mb-3 group-hover:scale-110 transition-transform inline-block',
                                            doc.type === 'pdf' ? 'fas fa-file-pdf text-red-500' :
                                            doc.type === 'image' ? 'fas fa-file-image text-gray-600' :
                                            doc.type === 'word' ? 'fas fa-file-word text-blue-600' :
                                            doc.type === 'excel' ? 'fas fa-file-excel text-green-600' :
                                            'fas fa-file text-gray-400'
                                        ]"></i>
                                        <h4 class="text-sm font-semibold text-gray-800 truncate" :title="doc.nom">{{ docTypeLabel[doc.type] }}</h4>
                                        <p v-if="doc.appareil" class="text-xs text-gray-500 mt-1 truncate">{{ doc.appareil.marque }} {{ doc.appareil.model }}</p>
                                        <p v-if="doc.manually" class="text-xs text-gray-500 mt-1 truncate">Ajouté manuellement</p>
                                        <p v-if="doc.type == 'bon_intervention' && !doc.intervention_id" class="text-xs text-gray-500 mt-1 truncate">Lié au chantier</p>
                                        <button @click.prevent="removeDoc(doc.id)" v-if="doc.manually" class="text-xs text-gray-500 hover:text-red-500 duration-200 mt-1 truncate">Supprimer</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="selectedTab === 'facturation'" class="space-y-6">
                        <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                            <invoice-ai-form :chantier-id="chantier.id" @invoice-created="getChantier(false)" />
                        </div>
                        
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div 
                                v-for="facture in chantier.factures" 
                                :key="'facture-' + facture.id" 
                                class="bg-white rounded-2xl border border-gray-100 p-5 hover:border-red-300 hover:shadow-sm transition-all cursor-pointer"
                            >
                                <a :href="facture.document_url" target="_blank" class="flex flex-col h-full">
                                    <div class="flex justify-between items-start mb-4">
                                        <div class="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
                                            <i class="fas fa-file-invoice-dollar"></i>
                                        </div>
                                        <span class="px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                                            {{ facture.status }}
                                        </span>
                                    </div>
                                    <div>
                                        <p class="text-sm font-bold text-gray-800 truncate">{{ facture.invoice_number || 'Facture #' + facture.num_invoice }}</p>
                                        <div class="flex justify-between items-end mt-2">
                                            <p class="text-xs text-gray-400">{{ new Date(facture.created_at).toLocaleDateString('fr-FR') }}</p>
                                            <p class="text-lg font-bold text-gray-800">{{ facture.total_ttc }}€</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DocType from './../../../config/docType.js';
import InvoiceAiForm from '../../Facturation/Components/InvoiceAiForm.vue';
import InterventionView from '../../Intervention/Components/InterventionView.vue';
import InterventionFormChantier from '../../Intervention/Components/InterventionFormChantier.vue';
import Planner from "@/components/Planner.vue";
import PlanningPlanner from '../../Planning/Components/PlanningPlanner.vue';

import InterventionPlanningDay from "./../../Intervention/Components/InterventionPlanningDay.vue";
import PlanningHalfDay from "./../../Planning/Components/PlanningHalfDay.vue";

export default {
    components: {
        InvoiceAiForm,
        InterventionView,
        InterventionFormChantier,
        Planner,
        InterventionPlanningDay,
        PlanningPlanner,
        PlanningHalfDay
    },
    props: {
        chantierId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedTab: 'info',
            tabs: [
                { id: 'info', label: 'Informations', icon: 'fas fa-info-circle' },
                { id: 'interventions', label: 'Interventions', icon: 'fas fa-clipboard-check' },
                { id: 'planning', label: 'Planning', icon: 'fas fa-calendar-alt' },
                { id: 'documents', label: 'Documents', icon: 'fas fa-box-archive' },
                { id: 'facturation', label: 'Facturation', icon: 'fas fa-file-invoice-dollar' },
                // { id: 'statistiques', label: 'Statistiques', icon: 'fas fa-chart-bar' },
            ],
            chantier: null,
            docTypeLabel: DocType,
            loadingGetChantier: true, // Initialisé à true pour voir le skeleton au montage
            loadingReloadIntervention: false,
            
            // Données statiques demandées
            statsFakeData: {
                nbTechs: 3,
                tempsTechnicien: "42h 30m",
                kmParcourus: "315 km",
                nbInterventions: 8,
                nbAppareils: 14,
                chiffreAffaire: "18 450 €",
                depenseMateriel: "5 200 €",
                marge: "13 250 €",
                tempsChantier: "14 Jours"
            },

            newDoc: {
                url: '',
                type: ''
            },
            loadingAddDoc: false,

            selectedIntervention: null,

            _interventionMap: null,
            loadingTerminer: false,

            newIntervention: {},
            loadingNewIntervention: false,

            loadingResendDocuments: false,

            fakeTechniciens: [
                {
                    id: 20,
                    prenom: "Adrien",
                    nom: "Blanc",
                    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
                },
                {
                    id: 21,
                    prenom: "Victor",
                    nom: "Anweiler",
                    avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
                },
                {
                    id: 22,
                    prenom: "Thomas",
                    nom: "Durand",
                    avatar: ''
                }
            ],

            fakeEvents: [

                // Adrien
                {
                    type: "trajet",
                    date: "2026-02-28",
                    heure_debut: "07:30:00",
                    heure_fin: "07:50:00",
                    technicien_id: 20
                },
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "08:00:00",
                    heure_fin: "09:00:00",
                    intervention_id: 2154,
                    technicien_id: 20
                },
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "09:30:00",
                    heure_fin: "10:15:00",
                    intervention_id: 2156,
                    technicien_id: 20
                },

                // Lucas
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "07:45:00",
                    heure_fin: "08:30:00",
                    intervention_id: 3001,
                    technicien_id: 21
                },
                {
                    type: "trajet",
                    date: "2026-02-28",
                    heure_debut: "08:30:00",
                    heure_fin: "08:50:00",
                    technicien_id: 21
                },
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "09:00:00",
                    heure_fin: "10:30:00",
                    intervention_id: 3002,
                    technicien_id: 21
                },

                // Thomas
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "08:15:00",
                    heure_fin: "09:15:00",
                    intervention_id: 4001,
                    technicien_id: 22
                },
                {
                    type: "intervention",
                    date: "2026-02-28",
                    heure_debut: "10:00:00",
                    heure_fin: "11:30:00",
                    intervention_id: 4002,
                    technicien_id: 22
                }
            ],

            unplannedEvents: [
                {
                    intervention_id: 3001,
                    client_nom: "Dupont",
                    adresse: "22 Rue Sabine Zlatin",
                    duree_estimee: 60, // minutes
                    type: "intervention"
                },
                {
                    intervention_id: 3002,
                    client_nom: "Martin",
                    adresse: "12 Rue de Marseille",
                    duree_estimee: 90,
                    type: "intervention"
                },
                {
                    intervention_id: 3003,
                    client_nom: "Bernard",
                    adresse: "5 Avenue Berthelot",
                    duree_estimee: 45,
                    type: "intervention"
                },
                {
                    intervention_id: 3004,
                    client_nom: "Morel",
                    adresse: "8 Rue Garibaldi",
                    duree_estimee: 120,
                    type: "intervention"
                },
                {
                    intervention_id: 3005,
                    client_nom: "Petit",
                    adresse: "14 Cours Gambetta",
                    duree_estimee: 30,
                    type: "intervention"
                }
            ]
        }
    },
    computed: {
        modalInterventionWidth() {
            return window.innerWidth < 768 ? '100%' : '850px'; 
        },
        chantierTemps() {
            const events = this.chantier?.planning_events || [];
            const interventions = this.chantier?.interventions || [];

            // Temps total dispo (planning_events.estimation en minutes)
            const totalDispoMinutes = events.reduce((acc, e) => acc + (e.estimation || 0), 0);

            // Temps total planifié (interventions.duree_estimee en minutes)
            const totalPlanifieMinutes = interventions.reduce((acc, i) => acc + (parseFloat(i.duree_estimee) || 0), 0);

            // Heures restantes (peut être négatif)
            const resteMinutes = totalDispoMinutes - totalPlanifieMinutes;

            // Pourcentage utilisé (peut dépasser 100%)
            const pourcentage = totalDispoMinutes > 0
            ? Math.round((totalPlanifieMinutes / totalDispoMinutes) * 100)
            : 0;

            // Warning si dépassement
            const isOverflow = totalPlanifieMinutes > totalDispoMinutes;

            return {
                totalDispo:     totalDispoMinutes / 60,       // en heures
                totalPlanifie:  totalPlanifieMinutes / 60,    // en heures
                reste:          resteMinutes / 60,            // en heures (négatif si dépassement)
                pourcentage,                                  // ex: 110 si dépassement
                isOverflow,                                   // boolean
            };
        }
    },
    methods: {
        async getChantier(loading = true) {
            if (loading) {
                this.loadingGetChantier = true;
            }
            try {
                const response = await this.$request.post(`/chantiers/${this.chantierId}/view`);
                this.chantier = response;
            } catch (error) {
                console.error('Error fetching chantier:', error);
            } finally {
                this.loadingGetChantier = false;
                this.showInterventionMap();
                this.$forceUpdate()
            }
        },

        async addDocument() {
            if (!this.newDoc.url) {
                this.$toast.error("Veuillez sélectionner un fichier à télécharger.");
                return;
            }
            if (!this.newDoc.type) {
                this.$toast.error("Veuillez sélectionner un type de document.");
                return;
            }

            this.loadingAddDoc = true
            await this.$request.post('/interventions/add-doc', {
                url: this.newDoc.url,
                type: this.newDoc.type || 'autre',
                chantier_id: this.chantier.id
            });
            this.loadingAddDoc = false

            this.newDoc = {};

            this.$toast.success("Document ajouté avec succès.");
            this.getChantier(false)
        },

        async removeDoc(docId) {
            if (confirm("Êtes-vous sûr de vouloir supprimer ce document ? Cette action est irréversible.")) {
                await this.$request.post('/interventions/remove-doc', {
                    id: docId
                });
                this.getChantier(false)
            }
        },

        showInterventionMap() {
            if (!this.chantier || !this.chantier || !this.chantier.adresse) return;
            const adr = this.chantier.adresse;
            if (!adr || !adr.latitude || !adr.longitude) return;

            mapboxgl.accessToken = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg';

            window.setTimeout(() => {
                if (this._interventionMap) {
                    this._interventionMap.remove();
                }

                this._interventionMap = new mapboxgl.Map({
                    container: 'intervention-map-chantier',
                    style: 'mapbox://styles/mapbox/streets-v12',
                    center: [parseFloat(adr.longitude), parseFloat(adr.latitude)],
                    zoom: 14
                });

                new mapboxgl.Marker({ color: '#e11d48' })
                    .setLngLat([parseFloat(adr.longitude), parseFloat(adr.latitude)])
                    .addTo(this._interventionMap);
            }, 400);
        },

        async terminer() {
            if (confirm("Êtes-vous sûr de vouloir terminer ce chantier ? Cette action est irréversible.")) {
                this.loadingTerminer = true
                await this.$request.post(`/chantiers/cloturer`, {
                    chantier_id: this.chantier.id
                });
                this.$toast.success("Chantier clôturé");
                this.$emit('chantier-ended');
                this.loadingTerminer = false
            }
        },

        async supprimerIntervention(id) {
            if (!confirm("Supprimer cette intervention ?")) return;

            await this.$request.post("/interventions/" + id + "/delete");
            this.$toast.success("Intervention supprimée");
            this.getChantier(false);
        },


        async createIntervention() {
            this.loadingNewIntervention = true
            this.newIntervention.chantier_id = this.chantier.id;
            this.newIntervention.client_id = this.chantier.client_id;
            this.newIntervention.adresse_id = this.chantier.adresse_id;
            let response = await this.$request.post('/interventions', this.newIntervention);
            if (response && response.intervention) {
                this.$toast.success("Intervention enregistrée");
                this.$eventHub.$emit('refresh-intervention-table');
                this.$modal.hide(this.id ? this.id : 'modal-add-intervention');
                this.formIntervention = {}
            } else {
                this.$toast.error("Une erreur est survenue lors de l'enregistrement de l'intervention");
            }
            this.loadingNewIntervention = false

            // if (planifier) {
            //     // this.$modal.show('modal-planify-intervention', { intervention_id: response.id });
            //     this.planInterventionId = response.intervention.id;
                
            //     let mapIntervention = {...response.intervention}
            //     mapIntervention.adresse = (mapIntervention.adresse?.code_postal || '-') + " " + (mapIntervention.adresse?.ville || '-');
            //     mapIntervention.client_adresse = response.intervention.adresse;
            //     this.planIntervention = mapIntervention;
            // }

            this.$modal.hide('modal-create-intervention')
            this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier')
            this.loadingReloadIntervention = true
            await this.getChantier(false)
            this.loadingReloadIntervention = false
        },

        async resendDocuments() {
            this.loadingResendDocuments = true;
            try {
                await this.$request.post('chantier/send-documents', {
                    chantier_id: this.chantier.id
                });
                this.$toast.success("Documents renvoyés au client avec succès.");
            } catch (error) {
                console.error("Error resending documents:", error);
                this.$toast.error("Une erreur est survenue lors de l'envoi des documents.");
            } finally {
                this.loadingResendDocuments = false;
            }
        }
    },
    mounted() {
        this.getChantier();
    }
}
</script>